export const buildOptions = (repeated) => {
  const options = {
    float: false,
    acceptWidgets: true,
    columnOpts: {
      breakpointForWindow: false,
      breakpoints: [
        { c: 48, w: 600 },
        { c: 72, w: 800 },
        { c: 96, w: 950 },
        { c: 120, w: 1100 },
      ],
      layout: "moveScale",
      columnMax: 120,
    },
    margin: 2,
    cellHeight: 20,
    resizable: { handles: "all" },
    children: [],
  };

  // Propagar restricciones a cada panel
  const mapPanelWithLimits = (panel) => {
    const { minWidth, maxWidth, minHeight, maxHeight, ...rest } = panel;
    return {
      ...rest,
      minW: minWidth,
      maxW: maxWidth,
      minH: minHeight,
      maxH: maxHeight,
    };
  };

  if (!repeated) return options;
  if (Array.isArray(repeated)) {
    const map = repeated.reduce((m, c) => ({ ...m, [c.id]: c }), {});
    const children = Object.keys(map).map((id) => mapPanelWithLimits(map[id]));
    return { ...options, children };
  }

  return { ...options, children: [mapPanelWithLimits(repeated)] };
};

export const mapPanel = ({
  x,
  y,
  w,
  h,
  id,
  tableId,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
}) => ({
  x,
  y,
  w,
  h,
  id,
  tableId,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
});
